import { HttpLink } from '@apollo/client'

import { retryingPromise } from '@emico/utils'

import makeHttpLinkUri from './makeHttpLinkUri'

function createBase64String(string: string) {
  if (typeof btoa === 'function') {
    return btoa(string)
  }

  return Buffer.from(string).toString('base64')
}

export default function createLink(uri: string, storeView: string) {
  const headers: Record<string, string> = {
    Store: storeView,
  }

  if (
    process.env.REACT_APP_APOLLO_BASIC_AUTH_USER ||
    process.env.REACT_APP_APOLLO_BASIC_AUTH_PASSWORD
  ) {
    headers.Authorization = `Basic ${createBase64String(
      `${process.env.REACT_APP_APOLLO_BASIC_AUTH_USER}:${process.env.REACT_APP_APOLLO_BASIC_AUTH_PASSWORD}`,
    )}`
  }

  return new HttpLink({
    uri: makeHttpLinkUri(uri),
    fetch: (...args) => retryingPromise(() => fetch(...args)),
    headers,
  })
}

// create a link for the store like this?
//
// import { ApolloLink } from '@apollo/client';
//
// const authLink = new ApolloLink((operation, forward) => {
//   operation.setContext(({ headers }) => ({ headers: {
//     authorization: Auth.userId(), // however you get your token
//     ...headers
//   }}));
//   return forward(operation);
// });
